import script from "./RecipientChipInput.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipientChipInput.vue?vue&type=script&setup=true&lang=js"

import "./RecipientChipInput.vue?vue&type=style&index=0&id=4fc7493e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fc7493e"]])

export default __exports__